import Button from 'primevue/button';
import Dialog from 'primevue/dialog';
// ConfirmationPopup.js
import { defineComponent, h, onMounted, onUnmounted, ref } from 'vue';
import { useEventBus } from './eventBus';

export default defineComponent({
  name: 'ConfirmationPopup',
  setup() {
    const visible = ref(false);
    const popupTitle = ref('');
    const popupMessage = ref('');
    const eventBus = useEventBus();

    const showPopup = (title, message) => {
      popupTitle.value = title;
      popupMessage.value = message;
      visible.value = true;
    };

    const hidePopup = () => {
      visible.value = false;
    };

    const onAction = () => {
      eventBus.emit(popupMessage.value.toLowerCase());
      hidePopup();
    };

    const onCancel = () => {
      eventBus.emit('cancel');
      hidePopup();
    };

    onMounted(() => {
      eventBus.on('showPopup', showPopup);
    });

    onUnmounted(() => {
      eventBus.off('showPopup', showPopup);
    });

    return () =>
      h(
        Dialog,
        {
          modelValue: visible.value,
          'onUpdate:modelValue': (value) => {
            visible.value = value;
          },
          modal: true,
          header: popupTitle.value,
          style: { width: '350px' },
          closable: false,
        },
        {
          default: () => h('p', { class: 'm-0' }, popupMessage.value),
          footer: () =>
            h('div', { class: 'flex justify-end space-x-2' }, [
              h(Button, {
                label: 'Annulla',
                onClick: onCancel,
                class: 'p-button-text',
              }),
              h(Button, {
                label: popupMessage.value,
                onClick: onAction,
                autofocus: true,
              }),
            ]),
        },
      );
  },
});

// // In un componente qualsiasi che necessita di attivare il popup
// import { useEventBus } from './eventBus';

// export default {
//   setup() {
//     const eventBus = useEventBus();

//     function triggerPopup() {
//       eventBus.emit('showPopup', 'Conferma Azione', 'Arma');
//     }

//     // Ascolta gli eventi dal popup
//     eventBus.on('arma', () => {
//       console.log('Sistema armato');
//     });

//     eventBus.on('disarma', () => {
//       console.log('Sistema disarmato');
//     });

//     eventBus.on('cancel', () => {
//       console.log('Azione annullata');
//     });

//     return { triggerPopup };
//   }
// }
